var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links-btn"},[_c('a',{staticClass:"btn border white",attrs:{"id":"needHelpLink","href":_vm.$t('https://link.ores.be/faq/fr'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t("Besoin d'aide ?")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }